import React from 'react';
import PropTypes from 'prop-types';

import EventModel from 'models/event';
import VenueModel from 'models/venue';
import { ParkingPass as ParkingPassModel } from 'models/parking-passes';

export default function EventInfo({ parkingPass, event, venue }) {
  if (event && venue) {
    let packageName;
    if (parkingPass.packageName) {
      packageName = (<div className="package-name h6-sg text-weight-medium text-color-dark-slate">
        {parkingPass.packageName}
      </div>);
    }

    return (
      <div className="event-info row text-center">
        { packageName }
        <div className="event-name h1-sg h2-sg-print text-weight-bold text-color-dark-slate">{event.name}</div>
        <div className="venue-name h6-sg text-weight-book text-color-dark-slate">{venue.name}</div>
      </div>
    );
  }

  return null;
}

EventInfo.propTypes = {
  parkingPass:  PropTypes.instanceOf(ParkingPassModel).isRequired,
  event:  PropTypes.instanceOf(EventModel),
  venue:  PropTypes.instanceOf(VenueModel),
};

EventInfo.defaultProps = {
  event: null,
  venue: null,
};
